import { createContext, useState, ReactNode } from "react";

// Update the type definition to reflect new fields
type AlertsControlBarContextType = {
  hasNextAlert: boolean;
  setHasNextAlert: (newhasNextAlert: boolean) => void;
  hasPreviousAlert: boolean;
  setHasPreviousAlert: (newhasPreviousAlert: boolean) => void;

  activeAlert: any;
  setActiveAlert: (newActiveAlert: any) => void;
};

// Update the initial value to only include the new fields
const initialValue: AlertsControlBarContextType = {
  activeAlert: null,
  setActiveAlert: () => {},
  hasNextAlert: false,
  setHasNextAlert: () => {},
  hasPreviousAlert: false,
  setHasPreviousAlert: () => {},
};

// Create the context with the new initial value
export const AlertsControlBarContext =
  createContext<AlertsControlBarContextType>(initialValue);

// Update the provider component to manage and provide the new state properties
export default function AlertsControlBarProvider({
  children,
}: {
  children?: ReactNode;
}) {
  const [activeAlert, setActiveAlert] = useState<any>(initialValue.activeAlert);
  const [hasNextAlert, setHasNextAlert] = useState<boolean>(
    initialValue.hasNextAlert,
  );
  const [hasPreviousAlert, setHasPreviousAlert] = useState<boolean>(
    initialValue.hasPreviousAlert,
  );

  return (
    <AlertsControlBarContext.Provider
      value={{
        hasNextAlert,
        setHasNextAlert,
        hasPreviousAlert,
        setHasPreviousAlert,
        activeAlert,
        setActiveAlert,
      }}
    >
      {children}
    </AlertsControlBarContext.Provider>
  );
}
